const BASE_API = '/power-cable-base'
export {BASE_API}